import React, { createContext, useState, useContext, useEffect } from "react";

const BrandContext = createContext();

export const BrandProvider = ({ children }) => {
  const [selectedBrand, setSelectedBrand] = useState(() => {
    // Cargar brand del localStorage si existe
    return localStorage.getItem("selectedBrand") || null;
  });

  // Persistir en localStorage cuando cambia el brand
  useEffect(() => {
    if (selectedBrand) {
      localStorage.setItem("selectedBrand", selectedBrand);
    }
  }, [selectedBrand]);

  return (
    <BrandContext.Provider value={{ selectedBrand, setSelectedBrand }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error("useBrand must be used within a BrandProvider");
  }
  return context;
};
